import { useEffect } from "react";
import Features from "../../assets/features.png";
import Map from "../../assets/map.svg";
import ContactFloating from "../../components/contact-floating";
import './Servicios.styles.scss';

const Servicios = () => {
    useEffect(() => {
        // Scroll to top when component mounts
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="servicios-page">
            <section className="servicios-hero section animate__animated animate__fadeIn">
                <div className="container servicios-container">
                    <h1 className="section-title">Nuestros Servicios</h1>
                    
                    <div className="services-intro">
                        <p className="intro-text">
                            En Dindorf ofrecemos servicios integrales de mecánica automotor con más de 60 años de experiencia. 
                            Nuestro equipo de profesionales está capacitado para atender todo tipo de vehículos, 
                            tanto nacionales como importados, con tecnología de última generación.
                        </p>
                    </div>

                    <div className="services-content">
                        {/* <div className="services-image">
                            <img src={Features} alt="Taller Mecánico" />
                        </div> */}

                        <div className="services-grid">
                            <div className="service-card service-card-1">
                                <div className="service-icon">
                                    <i className="ri-tools-line"></i>
                                </div>
                                <h3 className="service-title">MECÁNICA</h3>
                                <p className="service-description">
                                    Mecánica <br /> en General
                                </p>
                            </div>

                            <div className="service-card service-card-2">
                                <div className="service-icon">
                                    <i className="ri-home-gear-line"></i>
                                </div>
                                <h3 className="service-title">MOTORES</h3>
                                <p className="service-description">
                                    Nafta, Diesel y GNC <br /> Nacionales e Importados
                                </p>
                            </div>

                            <div className="service-card service-card-3">
                                <div className="service-icon">
                                    <i class="ri-stop-circle-line"></i>
                                </div>
                                <h3 className="service-title">FRENOS</h3>
                                <p className="service-description">
                                    Reparación y <br /> Mantenimiento
                                </p>
                            </div>

                            <div className="service-card service-card-4">
                                <div className="service-icon">
                                    <i className="ri-settings-3-line"></i>
                                </div>
                                <h3 className="service-title">CAJA</h3>
                                <p className="service-description">
                                    Caja y <br /> Embrague
                                </p>
                            </div>

                            <div className="service-card service-card-5">
                                <div className="service-icon">
                                    <i className="ri-cpu-line"></i>
                                </div>
                                <h3 className="service-title">INYECCIÓN</h3>
                                <p className="service-description">
                                    Inyección <br /> Electrónica
                                </p>
                            </div>

                            <div className="service-card service-card-6">
                                <div className="service-icon">
                                    <i className="ri-refresh-line"></i>
                                </div>
                                <h3 className="service-title">CORREA</h3>
                                <p className="service-description">
                                    Cambio de <br /> Correa de Distribución
                                </p>
                            </div>
                            <div className="service-card service-card-6">
                                <div className="service-icon">
                                    <i class="ri-steering-2-line"></i>
                                </div>
                                <h3 className="service-title">SERVICE EXPRESS</h3>
                                <p className="service-description">
                                    Cambio rápido <br /> y garantizado
                                </p>
                            </div>
                            <div className="service-card service-card-6">
                                <div className="service-icon">
                                    <i class="ri-computer-line"></i>
                                </div>
                                <h3 className="service-title">DIAGNOSTICO COMPUTARIZADO</h3>
                                <p className="service-description">
                                    Control preciso <br /> y seguro
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Sección de información adicional */}
                    <div className="additional-services">
                        <h2 className="additional-title">¿Por qué elegirnos?</h2>
                        <div className="benefits-grid">
                            <div className="benefit-item">
                                <div className="benefit-icon">
                                    <i className="ri-time-line"></i>
                                </div>
                                <h3>Experiencia</h3>
                                <p>Más de 60 años brindando servicios de calidad en el sector automotor</p>
                            </div>
                            
                            <div className="benefit-item">
                                <div className="benefit-icon">
                                    <i className="ri-shield-check-line"></i>
                                </div>
                                <h3>Garantía</h3>
                                <p>Todos nuestros trabajos cuentan con garantía y respaldo técnico</p>
                            </div>
                            
                            <div className="benefit-item">
                                <div className="benefit-icon">
                                    <i className="ri-customer-service-line"></i>
                                </div>
                                <h3>Atención Personalizada</h3>
                                <p>Trato cercano y profesional, asesoramiento técnico especializado</p>
                            </div>
                            
                            <div className="benefit-item">
                                <div className="benefit-icon">
                                    <i class="ri-macbook-line"></i>
                                </div>
                                <h3>Equipamiento Moderno</h3>
                                <p>Herramientas y tecnología de última generación para mejores resultados</p>
                            </div>
                        </div>
                    </div>

                    {/* Call to action */}
                    <div className="cta-section">
                        <h2 className="cta-title">¿Necesitas reparar tu vehículo?</h2>
                        <p className="cta-description">
                            Contactanos ahora para obtener un presupuesto sin compromiso
                        </p>
                        <button
                            className="cta-button"
                            onClick={() =>
                                window.open(
                                    'https://wa.me/2635000305?text=Hola,%20quisiera%20hacer%20una%20consulta%20de%20servicios',
                                    '_blank'
                                )
                            }
                        >
                            <i className="ri-whatsapp-line"></i>
                            Contactar Servicios
                        </button>
                    </div>
                </div>

                <img src={Map} alt="mapa" className="background-map" />
            </section>

            <ContactFloating />
        </div>
    );
};

export default Servicios;